import { render, staticRenderFns } from "./PseudoApps.vue?vue&type=template&id=65ce516a&scoped=true"
import script from "./PseudoApps.vue?vue&type=script&lang=js"
export * from "./PseudoApps.vue?vue&type=script&lang=js"
import style0 from "./PseudoApps.vue?vue&type=style&index=0&id=65ce516a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ce516a",
  null
  
)

export default component.exports